import React, { Component } from "react";
import PageTitle from "../../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import withRouter from "../../../Utils/withRouter";
import { ConfigContext } from "../../../Context/ConfigContext";
import { Link } from "react-router-dom";
import { currentDateAndTime, decodeData,encodeData, decodeUrl} from "../../../Constants/constants";
import { NoRecords } from "../../../Components/Shimmer";
import { NavLink } from "react-router-dom";


class SignatureList extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      keyword: '',
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      decodedData: [],
      decodedDataId:'',

    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
         if (prevState.permissions !== this.context.permissions) {
           // console.log("Permissions Updated:", this.context.permissions);
             const { permissions } = this.context;
             if (permissions.length > 0) {
               const queryParams = new URLSearchParams(window.location.search);
               const encodedData = queryParams.get("abs");
               const decodedDataId = decodeUrl(encodedData);
               
               const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
               if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({encodedData,decodedDataId, decodedData });
              }
             } else {
               console.warn("Permissions not yet available. Retrying...");
             }
         }
    }
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetSignatures`, {
        params: { limit: this.state.limit, page: this.state.page, keyword: this.state.keyword },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  handleInputSearch = (e) => {
    this.GetList();
  }
  handleClearAll = () => {
    this.setState({
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
    }
      , () => {
        this.GetList();
      });
  };
  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          signatory_id: id,
          date: currentDateAndTime()
        };
        axios
          .post(`${apiURL}Masters/DeleteSignature`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? "Success" : "Failed"
                }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
      }
    );
  };
  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1,
      },
      () => {
        this.GetList();
      }
    );
  };
  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500, this.state.total_records];
    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Signature List`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">

                      <div className='col-md-6'>
                        <label htmlFor="keyword">Signatory Name</label>
                        <div className="input-group">
                          <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search by signatory name" />
                          <button className="btn btn-success" onClick={this.handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                          <button className="btn btn-secondary ms-3" disabled={!this.state.keyword} onClick={this.handleClearAll} type="button" id="button-addon2">Show All</button>
                        </div>
                      </div>
                      { this.state.decodedData?.includes(2) && (
                      <div className="col-md-6">
                        <Link type="button" to={'/NewSignatoryMaster'}   style={{ float: 'right' }} className="btn btn-success btn-label waves-effect right waves-light mt-4">
                        <i className=" bx bx-add-to-queue label-icon align-middle fs-16 ms-2" /> Add Signature Master
                      </Link>
                      </div>)}
                    </div>
                  </div>
                  <table className={`table table-bordered table-hover`}>
                    <thead className="table-light">
                      <tr>
                        <th>Signature Name</th>
                        <th>Signatory Email</th>
                        <th>Signature Number</th>
                        <th>Signature Level</th>
                        <th>Signature Type</th>
                        { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                        <th className="text-center">Action</th>)}
                      </tr>
                    </thead>
                    {this.state.rows.length === 0 ? (
                            <tbody>
                              <tr>
                                <td colSpan={14}>
                                  <NoRecords />
                                </td>
                              </tr>
                            </tbody>
                          ):
                    <tbody>
                      {this.state.rows.map((row) => {
                        return (
                          <tr key={row.signatory_id}>
                            <td>{row.signatory_name}</td>
                            <td>{row.signatory_email}</td>
                            <td>{row.signatory_number}</td>
                            <td>{row.signatory_authorization_level}</td>
                            <td>{row.signatory_identification_type}</td>
                            { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                            <td className="d-flex justify-content-around">
                              { this.state.decodedData?.includes(3) && (
                              // <Link to={`/NewSignatoryMaster/${row.signatory_id}`}
                                <NavLink to={`/NewSignatoryMaster/${row.signatory_id}?abs=${encodeData(this.state.decodedDataId)}`}>
                               <button 
                                    type="button"
                                    className="btn-icon btn btn-sm btn-outline-primary"
                                    >
                                      <i className="ri-edit-box-line"></i>
                               </button>
                              </NavLink>)}
                              { this.state.decodedData?.includes(4) && (
                              <button onClick={() => this.handleDelete(row.signatory_id)}
                                className="btn-icon btn btn-sm btn-outline-danger">
                                <i className="ri-delete-bin-line"></i>
                              </button>)}
                            </td>)}
                          </tr>
                        );
                      })}
                    </tbody>}
                    <tfoot className="table-light">
                      <tr>
                        <th colSpan={7}>
                          <div className="d-flex justify-content-between">
                            <button
                              disabled={
                                this.state.prev === false &&
                                  this.state.loadingList === false
                                  ? true
                                  : false
                              }
                              type="button"
                              onClick={() => this.handlePrev()}
                              className={`btn btn-warning btn-label waves-effect waves-light`}
                            >
                              <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                              Previous
                            </button>
                            <div
                              className="col-md-4"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {
                                <small>
                                  Total Records: {this.state.total_records} |
                                  Total Pages: {this.state.total_pages} |
                                  Current Page: {this.state.page}
                                </small>
                              }
                            </div>
                            <div className="col-md-2">
                              <select
                                className="form-select"
                                onChange={(e) => this.handleChange(e)}
                              >
                                {Array.from(
                                  { length: this.state.total_pages },
                                  (_, i) => (
                                    <option
                                      selected={this.state.page === i + 1}
                                      key={i}
                                      value={i + 1}
                                    >
                                      Page {i + 1}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                            <div className="col-md-2">
                              <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                {limitOptions.map((option) => (
                                  <option key={option} value={option}>
                                    Limit {option}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <button
                              disabled={
                                this.state.next === false &&
                                  this.state.loadingList === false
                                  ? true
                                  : false
                              }
                              type="button"
                              onClick={() => this.handleNext()}
                              className={`btn btn-primary btn-label waves-effect right waves-light`}
                            >
                              <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                              Next
                            </button>
                          </div>
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(SignatureList);
